import React, { useState, useEffect, useRef, useMemo } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2';
import { Editor } from 'primereact/editor';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Quill from 'quill'; // Bu satırı ekle
import ImageResize from 'quill-image-resize-module-react';

// Sonra kayıt işlemini yap:
Quill.register('modules/imageResize', ImageResize);


export const AdminMessage = () => {
    const { user } = useAuth();
    const currentUserId = user.user.id || user.nameid;
    const editorRef = useRef(null);

    const [title, setTitle] = useState("");
    const [coverImage, setCoverImage] = useState("");
    const [content, setContent] = useState("");
    const [targetGroup, setTargetGroup] = useState("all_users");
    const [messages, setMessages] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);

    const API_URL = "https://express.heryerdeingilizce.com/api/messages";
    const UPLOAD_API_URL = "https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile";

    // ÖZEL RESİM YÜKLEME FONKSİYONU
    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('FormFile', file);
                formData.append('mediaType', 'photo');

                try {
                    Swal.fire({ title: 'Yükleniyor...', allowOutsideClick: false, didOpen: () => { Swal.showLoading() } });
                    const response = await axios.post("https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile", formData, {
                        headers: { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'multipart/form-data' }
                    });

                    if (response.data.success) {
                        Swal.close();
                        const imageUrl = "https://api.heryerdeingilizce.com/" + response.data.data.path;
                        const quill = editorRef.current.getQuill();
                        const range = quill.getSelection(true);
                        quill.insertEmbed(range.index, 'image', imageUrl);
                    }
                } catch (error) {
                    Swal.fire("Hata", "Resim yüklenemedi.", "error");
                }
            }
        };
    };
    // TOOLBAR AYARI (Boş selectleri engellemek için özelleştirilmiş liste)
    const headerTemplate = (
        <span className="ql-formats">
            <select className="ql-header" defaultValue="0">
                <option value="1">Başlık 1</option>
                <option value="2">Başlık 2</option>
                <option value="0">Normal</option>
            </select>
            <button className="ql-bold" aria-label="Bold"></button>
            <button className="ql-italic" aria-label="Italic"></button>
            <button className="ql-underline" aria-label="Underline"></button>
            <button className="ql-image" aria-label="Image"></button>
            <button className="ql-link" aria-label="Link"></button>
            <button className="ql-clean" aria-label="Clean"></button>
        </span>
    );

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!content || content === "<p><br></p>") {
            Swal.fire("Uyarı", "İçerik boş olamaz.", "warning");
            return;
        }

        try {
            Swal.fire({ title: 'Gönderiliyor...', allowOutsideClick: false, didOpen: () => { Swal.showLoading() } });
            await axios.post(`${API_URL}/send`, {
                title, cover_image: coverImage, content: encodeURIComponent(content),
                targetGroup, token: user.token, senderId: currentUserId
            });
            Swal.fire("Başarılı!", "Mesaj gönderildi.", "success");
            setTitle(""); setCoverImage(""); setContent("");
            fetchMessagesData();
        } catch (error) {
            Swal.fire("Hata!", "Gönderilemedi.", "error");
        }
    };

    const fetchMessagesData = async () => {
        if (!currentUserId) return;
        setLoading(true);
        try {
            const listRes = await axios.get(`${API_URL}/list/${currentUserId}`);
            setMessages(listRes.data.data || []);
            const countRes = await axios.get(`${API_URL}/unread-count/${currentUserId}`);
            setUnreadCount(countRes.data.count || 0);
        } catch (error) { }
        setLoading(false);
    };

    const handleReadMessage = async (id) => {
        try {
            const res = await axios.get(`${API_URL}/detail/${id}/${currentUserId}`);
            if (res.data.success) {
                setSelectedMessage(res.data.data);
                setShowModal(true);
                if (!res.data.data.is_read) fetchMessagesData();
            }
        } catch (error) { }
    };

    useEffect(() => { fetchMessagesData(); }, [currentUserId]);

    return (
        <div className="container py-4">
            <h2 className="text-center mb-4">Mesaj Yönetim Sistemi</h2>

            <div className="card p-4 shadow-sm">
                <form onSubmit={handleSendMessage}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">Hedef Kitle</label>
                            <select className="form-select" value={targetGroup} onChange={e => setTargetGroup(e.target.value)}>
                                <option value="all_users">Tüm Kullanıcılar</option>
                                <option value="managers">Yöneticiler</option>
                                <option value="lecturers">Öğretmenler</option>
                                <option value="students">Öğrenciler</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Başlık</label>
                            <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} required />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Kapak Resmi (URL)</label>
                        <input type="text" className="form-control" value={coverImage} onChange={e => setCoverImage(e.target.value)} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Mesaj İçeriği</label>
                        <Editor
                            ref={editorRef}
                            value={content}
                            onTextChange={(e) => setContent(e.htmlValue || "")}
                            headerTemplate={headerTemplate} // Özel temiz template
                            onLoad={(quill) => {
                                quill.getModule('toolbar').addHandler('image', imageHandler);
                            }}
                            style={{ height: '320px' }}
                        />
                    </div>
                    <div className="text-center">
                        <button type="submit" className="btn btn-primary btn-lg px-5">Gönder</button>
                    </div>
                </form>
            </div>

            <hr className="my-5" />

            {/* TABLO VE MODAL KISIMLARI AYNI KALIYOR */}
            <div className="card p-3">
                <div className="d-flex justify-content-between mb-3">
                    <h3>Gelen Kutusu</h3>
                    <span className="badge bg-danger">{unreadCount} Okunmamış</span>
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>Durum</th>
                                <th>Başlık</th>
                                <th>Tarih</th>
                                <th>İşlem</th>
                            </tr>
                        </thead>
                        <tbody>
                            {messages.map(item => (
                                <tr key={item.id} style={{ fontWeight: item.is_read ? 'normal' : 'bold' }}>
                                    <td className="text-center">{item.is_read ? "Okundu" : "Yeni"}</td>
                                    <td>{item.title}</td>
                                    <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                    <td className="text-center">
                                        <button className="btn btn-sm btn-info text-white" onClick={() => handleReadMessage(item.id)}>Oku</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && selectedMessage && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="card p-0 shadow-lg" style={{ width: "800px", maxWidth: "90%", maxHeight: "90vh", overflowY: "auto", backgroundColor: "#fff" }}>
                        {selectedMessage.cover_image && <img src={selectedMessage.cover_image} alt="Kapak" style={{ width: "100%", maxHeight: "300px", objectFit: "cover" }} />}
                        <div className="card-body p-4">
                            <h3 className="card-title mb-3">{selectedMessage.title}</h3>
                            <div dangerouslySetInnerHTML={{ __html: decodeURIComponent(selectedMessage.content) }} />
                            <button className="btn btn-secondary mt-3" onClick={() => setShowModal(false)}>Kapat</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default AdminMessage;